<div class="breadcrumb">
  <div class="breadcrumb__left">
    <a class="breadcrumb__link" [routerLink]="baseRoute()" [state]="{ fromBreadcrumb: true }">
      <span class="breadcrumb__label--full">{{ prefixLabel() }}</span>
      <span class="breadcrumb__label--short">{{ shortPrefixLabel() }}</span>
    </a>
    @for (crumb of breadcrumbLevels(); track crumb.label; let isLast = $last) {
      <span class="breadcrumb__divider">/</span>
      @if (!isLast && crumb.route) {
        <a class="breadcrumb__crumb-link" [routerLink]="crumb.route" [state]="crumb.state ?? { fromBreadcrumb: true }">{{ crumb.label }}</a>
      } @else {
        <span class="breadcrumb__crumb-text">{{ crumb.label }}</span>
      }
    }
  </div>
  <div class="breadcrumb__right">
    Session Remaining: {{ remainingTimeText() }}
  </div>
</div>
